import React, { useState } from 'react';
import styled from 'styled-components';
import { ISupportLanguage } from 'utils/types/storyTypes';
import { theme } from 'utils/style/theme';
import { Radio, message } from 'antd';
import { useTranslation } from 'react-i18next';
import PrimaryButton from 'components/button/PrimaryButton';
import { Trash } from 'iconsax-react';
import ActionItems from './ActionItems';
import AddLanguageButton from 'components/AddLanguageButton';
import { handleMessage } from 'utils/helper/message';
import AddLangModal from './LanguageModal/AddLangModal';
import SelectStyled from 'components/SelectStyled';
import EditLangModal from './LanguageModal/EditLangModal';
import ConditionInput from './ConditionInput';

/**
 * * 오토메 - 작품 정보 수정
 */

interface IProps {
  langList: ISupportLanguage[] | null;
  data: any | null;
  detailData: any;
  index: number;
  setData: React.Dispatch<React.SetStateAction<any | null>>;
  conditions: any;
  motions: any;
}

export interface IVisible {
  addLang: boolean;
  editLang: boolean;
  name: string;
}

const Content: React.FC<IProps> = ({
  langList,
  data,
  detailData,
  index,
  setData,
  motions,
  conditions,
}) => {
  const [visible, setVisible] = useState<IVisible>({
    addLang: false,
    editLang: false,
    name: '',
  });
  const { t } = useTranslation();
  const [selectedEl, setSelectedEl] = useState<null | any>(null);

  const handleRemove = (index: number) => {
    if (data) {
      const cloneData = JSON.parse(JSON.stringify(data));
      cloneData.line.splice(index, 1);
      setData(cloneData);
    }
  };

  const handleClickDelete = (data, detailData, index, i) => {
    const cloneData = JSON.parse(JSON.stringify(data));
    const cloneDetailData = JSON.parse(JSON.stringify(detailData));
    cloneDetailData.localizations.splice(i, 1);
    cloneData.lines[index] = cloneDetailData;
    setData(cloneData);
  };

  const handleRemoveLang = () => {
    const cloneData = JSON.parse(JSON.stringify(data));
    if (cloneData.lines) {
      cloneData.lines.splice(index, 1);
      setData(cloneData);
    }
  };

  const handleAddLanguage = () => {
    if (detailData.localizations && detailData.localizations.length > 6) {
      handleMessage(message, 'error', 'Episode only can have 7 languages');
    } else {
      setVisible({ ...visible, addLang: true });
    }
  };

  const handleMotionChange = (value) => {
    const cloneData = JSON.parse(JSON.stringify(data));
    const cloneDetailData = JSON.parse(JSON.stringify(detailData));
    cloneDetailData['motion_name'] = value;
    cloneData.lines[index] = cloneDetailData;
    setData(cloneData);
  };

  const handleConditionChange = (value) => {
    const cloneData = JSON.parse(JSON.stringify(data));
    const cloneDetailData = JSON.parse(JSON.stringify(detailData));
    cloneDetailData['condition_type'] = value;
    if (value === 0) {
      cloneDetailData['line_condition'] = null;
    } else {
      cloneDetailData['line_condition'] = '';
    }
    cloneData.lines[index] = cloneDetailData;
    setData(cloneData);
  };

  return (
    <>
      <OtomeProjectContentWrapper>
        <SectionWarpper>
          <p className='title'>
            {t(
              'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.line',
            )}
          </p>
          <div className='langsTable'>
            <div className='langsTable-first'>
              <p className='title-table'>
                {t(
                  'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.language',
                )}
              </p>
            </div>
            <div className='langsTable-second'>
              <p className='title-table'>
                {t(
                  'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.editLanguageLineModal.lineText',
                )}
              </p>
            </div>
            <div className='langsTable-third'></div>
            {detailData?.localizations?.map((el, i) => {
              return (
                <>
                  <div className='langsTable-first'>
                    <p>{el?.lang}</p>
                  </div>
                  <div className='langsTable-second'>
                    <p>{el?.line_text}</p>
                  </div>
                  <div className='langsTable-third'>
                    <ActionItems
                      data={data}
                      detailData={detailData}
                      index={index}
                      i={i}
                      setSelectedEl={setSelectedEl}
                      visible={visible}
                      setVisible={setVisible}
                      handleClickDelete={handleClickDelete}
                    />
                  </div>
                </>
              );
            })}
          </div>
          <AddLanguageButton handleAddLanguage={handleAddLanguage} />
          <div>
            <p className='title'>
              {t(
                'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.motion',
              )}
              :
            </p>
            <SelectStyled
              size='large'
              bordered={false}
              defaultValue={detailData?.motion_name}
              style={{ width: '100%' }}
              onChange={(e) => {
                handleMotionChange(e);
              }}
              options={motions?.map((v, i) => {
                return {
                  value: v.code,
                  label: v.code_name,
                };
              })}
            />
          </div>
          <div>
            <p className='title'>
              {t(
                'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.condition',
              )}
            </p>
            <Radio.Group
              onChange={(e) => {
                handleConditionChange(e.target.value);
              }}
              value={detailData?.condition_type}
            >
              {conditions &&
                conditions.map((el, i) => {
                  return (
                    <Radio key={i} value={Number(el?.code)}>
                      {el?.code_name}
                    </Radio>
                  );
                })}
            </Radio.Group>
          </div>
          <div>
            <ConditionInput
              type={detailData?.condition_type}
              data={data}
              detailData={detailData}
              setData={setData}
              index={index}
            />
          </div>
          <RemoveButtonWrapper>
            <PrimaryButton
              text='Remove'
              height='40px'
              width='fit-content'
              bgColor='#ffffff'
              textColor={theme.colors.dark_400}
              fontWeight={theme.fontWeights.medium}
              fontSize={theme.fontSizes.normal}
              border={`1px solid ${theme.colors.gray_6}`}
              rounded='6px'
              hoverBgColor={theme.colors.gray_6}
              activeBgColor={theme.colors.gray_6}
              selectedBgColor={theme.colors.gray_6}
              onClick={handleRemoveLang}
              LeftPlaceHolder={<Trash size='24' />}
            />
          </RemoveButtonWrapper>
        </SectionWarpper>
        {data && data?.line?.length > 1 && (
          <div className='remove'>
            <PrimaryButton
              text='Remove'
              height='40px'
              width='fit-content'
              bgColor='#ffffff'
              textColor={theme.colors.dark_400}
              fontWeight={theme.fontWeights.medium}
              fontSize={theme.fontSizes.normal}
              border={`1px solid ${theme.colors.gray_6}`}
              rounded='6px'
              hoverBgColor={theme.colors.gray_6}
              activeBgColor={theme.colors.gray_6}
              selectedBgColor={theme.colors.gray_6}
              onClick={() => handleRemove(index)}
              LeftPlaceHolder={<Trash size='24' />}
            />
          </div>
        )}
      </OtomeProjectContentWrapper>
      <AddLangModal
        langList={langList}
        data={data}
        setData={setData}
        detailData={detailData}
        index={index}
        visible={visible}
        setVisible={setVisible}
      />
      <EditLangModal
        langList={langList}
        data={data}
        detailData={detailData}
        index={index}
        setData={setData}
        visible={visible}
        setVisible={setVisible}
        selectedEl={selectedEl}
      />
    </>
  );
};

export default Content;

const OtomeProjectContentWrapper = styled.div`
  border: 1px solid #bcbec0;
  padding: 1.5rem 1.5rem;
  border-radius: 8px;
  & > * + * {
    margin-top: 16px;
  }
  .title,
  .length-subtext {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .length-subtext {
    margin-top: 8px !important;
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_200};
  }
  .ant-input-show-count-suffix {
    display: none;
  }
  .remove {
    display: flex;
    justify-content: end;
  }
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
  .langsTable {
    display: flex;
    flex-wrap: wrap;
  }
  .langsTable-first {
    width: 40%;
  }
  .langsTable-second {
    width: 40%;
  }
  .langsTable-third {
    width: 20%;
    display: flex;
    justify-content: end;
    & > * + * {
      margin-left: 16px;
    }
  }
  .langsTable-first,
  .langsTable-second,
  .langsTable-third {
    border-bottom: 1px solid ${theme.colors.dark_200};
    padding: 12px;
    display: flex;
    align-items: center;
    p {
      font-size: ${theme.fontSizes.sm};
      font-style: normal;
      font-weight: ${theme.fontWeights.medium};
      line-height: 16px;
      letter-spacing: 0.2px;
      /* text-transform: capitalize; */
    }
  }
  .title-table {
    font-size: ${theme.fontSizes.normal} !important;
    font-weight: ${theme.fontWeights.bold} !important;
  }
`;

const RemoveButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
